import React from 'react';
import { Carousel } from 'antd';
import './index.less';
import bannerBg from '../../assets/tidy3d_banner_bg.png';
interface BannerItem {
  content: string;
  name: string;
  introduce: string;
  avatar: string;
}

interface BannerProps {
  items: BannerItem[];
}

const SideBanner: React.FC<BannerProps> = ({ items }) => {
  return (
    <div className="side_banner">
      <img className="banner_bg" src={bannerBg} alt="banner_bg" />
      <Carousel
        className="banner_carousel"
        autoplay
        autoplaySpeed={3000}
        dots={true}
        effect="fade"
        style={{ width: '100%', height: '100%' }}
      >
        {items.map(item => (
          <div key={item.name} className="banner_item">
            <p className="banner_content">{item.content}</p>
            <div className="banner_info">
              <img src={item.avatar} alt={item.name} />
              <div className="banner_info_content">
                <h2>{item.name}</h2>
                <p>{item.introduce}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default SideBanner;
